import { ContentBlockText, ContentBlockTitle } from '../../../components/ui/contentBlock'
import ContentPageHeader from '../../../components/ui/contentPageHeader'
import ExampleInvoiceImage from './ExampleInvoiceImage'
import ExampleInvoiceLink from './ExampleInvoiceLink'
import './styles.scss'

const STEPS = [
  {
    title: 'Sign in with Google or Microsoft',
    description:
      'Choose Google or Microsoft to set up your account. TinyInvoice.app saves only your name and email—no separate password to remember.',
  },
  {
    title: 'Create invoice',
    description:
      'Add your client, line items, and tax in a clean editor. Your logo and business details carry over so each invoice stays on-brand.',
  },
  {
    title: 'Download PDF or send it by email',
    description:
      'Email the invoice directly from TinyInvoice.app or download it to send yourself. Optional reminders help you get paid on time.',
  },
] as const

type Props = {
  /** Pre-rendered static homepage: example image/link updated by build-injected scripts. */
  staticLocalised?: boolean
}

const HowItWorks = ({ staticLocalised = false }: Props) => {
  return (
    <section
      id='how-it-works'
      className='how-it-works'
      aria-labelledby='how-it-works-heading'
    >
      <div className='container col-xxl-8 py-5'>
        <ContentPageHeader
          as='h2'
          id='how-it-works-heading'
          title='How it works'
          subtitle=''
        />

        <div className='row g-4 g-lg-5 align-items-center'>
          <div className='col-lg-6'>
            <ol className='how-it-works__steps list-unstyled mb-0'>
              {STEPS.map((step, index) => (
                <li key={step.title} className='how-it-works__step'>
                  <span className='how-it-works__step-marker' aria-hidden>
                    {index + 1}
                  </span>
                  <span className='how-it-works__step-content'>
                    <ContentBlockTitle>{step.title}</ContentBlockTitle>
                    <ContentBlockText as='div'>{step.description}</ContentBlockText>
                  </span>
                </li>
              ))}
            </ol>
          </div>

          <div className='col-lg-6 d-none d-lg-block'>
            <div className='how-it-works__visual'>
              <ExampleInvoiceImage
                staticMode={staticLocalised}
                className='how-it-works__visual-image'
              />
              <ExampleInvoiceLink
                staticMode={staticLocalised}
                className='how-it-works__example-link'
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HowItWorks
